.space_separator {
    display: flex;
    flex-wrap: wrap;
    align-items: center;

    font-weight: normal;
    word-wrap: none;

    .item {
        display: flex;
        align-items: center;
    }

    &[data-ellipsis="true"] {

        .item {
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }

    &[data-inline="true"] {
        display: inline-flex;
    }

    &[data-wrap="false"] {
        flex-wrap: nowrap !important;
    }

    .item {

        &:after {
            content: ",";

            margin: 0 5px;

            font-size: 14px;
            vertical-align: bottom;

            opacity: 0.8;
        }
    }

    &[data-separator="dot"] {

        .item {

            &:after {
                content: "•";
            }
        }
    }

    &[data-separator="comma"] {

        .item {

            &:after {
                content: ",";
                margin: 0 5px 0 1px;
            }
        }
    }

    &[data-separator="verticalBar"] {

        .item {

            &:after {
                content: "|";
            }
        }
    }

    &[data-separator="space"] {

        .item {

            &:after {
                content: " ";
            }
        }
    }

    &[data-separator="slash"] {

        .item {

            &:after {
                content: "/";
            }
        }
    }

    &[data-separator="arrowRight"] {

        .item {

            &:after {
                content: ">";
            }
        }
    }

    &[data-separator="hyphen"] {

        .item {

            &:after {
                content: "-";
            }
        }
    }

    .item:last-child{

        &:after {
            content: unset;
        }
    }
}
